const charactersUpTo = (input: string, limit: number): string => {
  if (!input) return ''
  return input.length > limit ? input.slice(0, limit) : input
}

export default charactersUpTo
